const pad2 = (n: number): string => String(n).padStart(2, '0');

const toValidDate = (value: string | Date | null | undefined): Date | null => {
  if (!value) return null;
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  return d;
};

export const formatDate = (value: string | Date | null | undefined): string => {
  const d = toValidDate(value);
  if (!d) return '—';
  return `${pad2(d.getDate())}.${pad2(d.getMonth() + 1)}.${d.getFullYear()}`;
};

export const formatDateTime = (value: string | Date | null | undefined): string => {
  const d = toValidDate(value);
  if (!d) return '—';
  return `${pad2(d.getDate())}.${pad2(d.getMonth() + 1)}.${d.getFullYear()} ${pad2(d.getHours())}:${pad2(d.getMinutes())}`;
};

const RELATIVE_THRESHOLDS: { limit: number; divisor: number; suffix: string }[] = [
  { limit: 60, divisor: 1, suffix: 's' },
  { limit: 3600, divisor: 60, suffix: 'm' },
  { limit: 86400, divisor: 3600, suffix: 'h' },
  { limit: 604800, divisor: 86400, suffix: 'd' },
];

export type RelativeTime = { kind: 'now' } | { kind: 'elapsed'; value: string } | { kind: 'date'; value: string };

export const formatRelativeTime = (value: string | Date | null | undefined): RelativeTime => {
  const d = toValidDate(value);
  if (!d) return { kind: 'now' };
  const elapsedSeconds = Math.max(0, (Date.now() - d.getTime()) / 1000);
  if (elapsedSeconds < 1) return { kind: 'now' };
  for (const { limit, divisor, suffix } of RELATIVE_THRESHOLDS) {
    if (elapsedSeconds < limit) {
      return { kind: 'elapsed', value: `${Math.floor(elapsedSeconds / divisor)}${suffix}` };
    }
  }
  return { kind: 'date', value: formatDateTime(d) };
};
